import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { useTranslations } from '@/i18n/translations';
import { FlowShell } from '@/components/onboarding/FlowShell';
import { ChecklistColumn } from '@/components/onboarding/ChecklistColumn';
import { useOnboardingProgress } from '@/components/onboarding/progress';
import { useFinishOnboarding } from '@/components/onboarding/finish-onboarding';
import { NL_ROLE, NL_STEPS } from './-steps';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

export const Route = createFileRoute('/onboarding/nl/complete')({
  component: NLOnboardingCompletePage,
});

function NLOnboardingCompletePage() {
  const navigate = useNavigate();
  const finish = useFinishOnboarding('nl');
  const t = useTranslations('Onboarding');
  const { data: progress } = useOnboardingProgress();

  return (
    <FlowShell
      role={NL_ROLE}
      stepIndex={5}
      steps={NL_STEPS}
      title="Explore your community."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Finish onboarding
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/nl/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        title={t('checklist.title.networkLeader')}
        steps={PERSONA_STEP_KEYS['network-leader']}
        progress={progress}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
